import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getMe } from 'redux/actions/auth';

import HomePage from './Home.page';

const mapStateToProps = state => ({
  me: state.auth.me,
});

const mapDispatchToProps = { getMe };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(HomePage));
